import React from 'react'

import {Grid, Row, Col} from 'react-flexbox-grid'
import {Link} from 'react-router'

import {AuthService, AuthStore} from 'api/auth'
import {Login, Register} from './'
import {Notify} from 'ui'

export class Logout extends React.Component {
   static get propTypes() {
      return {
         location: React.PropTypes.object.isRequired,
         router:   React.PropTypes.object.isRequired,
         route:    React.PropTypes.any.isRequired
      }
   }

   constructor(props) {
      super(props)
      this._notify = null
   }

   componentWillMount() {
      this._notify = new Notify.Store()

      if (AuthStore.auth || localStorage.auth) {
         AuthService.logout('component')
            .then(() => this.forceUpdate())
            .catch(() => this.forceUpdate())
      }
   }

   render() {
      console.log('render: auth/logout', window.location.hash)

      let {location, route, router} = this.props,
         authview = location.query.auth

      return (
         <div className="auth logout">
            <div className="featured">
               <Grid>
                  <Row between="sm">
                     <Col sm={5} className="text-center copy">
                        <h1>You are now logged out!</h1>

                        <p className="lead">
                           Thanks for using our service, if you did not mean to
                           logout use the form to sign back in.
                        </p>
                     </Col>
                     <Col sm={6}>
                        <Notify store={this._notify} />

                        <div style={{display: 'register' !== authview ? 'inherit' : 'none'}}>
                           <Login
                              notify={this._notify}
                              redirect="/dashboard"
                              router={router}
                              signupLink={{
                                 ...location,
                                 query: {...location.query, auth: 'register'}
                              }}
                           />
                        </div>

                        <div style={{display: 'register' === authview ? 'inherit' : 'none'}}>
                           <Register
                              notify={this._notify}
                              redirect="/dashboard"
                              router={router}
                              loginLink={{
                                 ...location,
                                 query: {...location.query, auth: 'login'}
                              }}
                           />
                        </div>
                     </Col>
                  </Row>
               </Grid>
            </div>
         </div>
      )
   }
}



// WEBPACK FOOTER //
// lib/bundle/auth/Logout.jsx